
import * as ApiWithToken from "../callApiWithToken";

const roleService = {
    getRoleList: async function (languageId: number, roleTypeId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Roles/GetRoleListByType?LanguageID=${languageId}&RoleTypeID=${roleTypeId}`);
    },
    getAdvisorList: async function (roleId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Roles/GetAdvisorListByRole?RoleID=${roleId}`);
    }
}
export default roleService;
